angular.module("app").controller("CasinoGamesEditPageController", [
    '$scope',
    'casinoGameService',
    'errorHandler',
    'preloadedCategories',
    'preloadedSubCategories',
    'logger',
    'preloadedGameData',
    'deepCompare',
    function ($scope, casinoGameService, errorHandler, preloadedCategories, preloadedSubCategories, logger, preloadedGameData, deepCompare) {
        var init;

        $scope.tooltip = {
            name: "",
            height: "",
            width: ""
        };

        $scope.save = function () {
            var fetchedData = fetchRequestData(),
                requestData = {
                    skinGame: angular.copy(fetchedData)
                };

            casinoGameService.editSkinGame(requestData).then(
                function (response) {
                    if (response.status === "ok") {
                        logger.logSuccess("updated");
                        preloadedGameData = angular.copy(fetchedData);
                    } else {
                        errorHandler(response.message)
                    }
                },
                function (response) {
                    errorHandler(response.message)
                }
            )
        };

        $scope.isAllowedToUpdate = function () {
            return deepCompare.isEqual(fetchRequestData(), preloadedGameData)
        };

        function fetchRequestData () {
            var fetchedData = angular.extend({}, $scope.gameData);


            fetchedData.categories = [];
            fetchedData.subCategories = [];

            $scope.multiSelect.selectedCategories.forEach(function (value) {
                fetchedData.categories.push(value.id)
            });
            $scope.multiSelect.selectedSubCategories.forEach(function (value) {
                fetchedData.subCategories.push(value.id)
            });

            return fetchedData
        }

        (init = function (gameData) {

            var categories = [],
                subCategories = [];
            $scope.multiSelect = {
                selectedCategories: function () {
                    var fetchedData = [];
                    gameData.categories.forEach(function (category) {
                        fetchedData.push({id: category.id})
                        categories.push(category.id)
                    });
                    return fetchedData
                } (),
                selectedSubCategories: function () {
                    var fetchedData = [];
                    gameData.subCategories.forEach(function (subCategory) {
                        fetchedData.push({id: subCategory.id});
                        subCategories.push(subCategory.id)
                    });
                    return fetchedData
                } (),
                categories: angular.copy(preloadedCategories),
                subCategories: angular.copy(preloadedSubCategories)
            };
            gameData.subCategories = angular.copy(subCategories);
            gameData.categories = angular.copy(categories);
            $scope.gameData = angular.copy(gameData);

        })(preloadedGameData)

    }
]);